/**
 *
 * @param price
 * @param discount discount should be the percentage not decimal e.g 2 = 2%
 */
export default function applyDiscount(price: number, discount: number) {
  const refinedDiscount = discount / 100;
  const discountedPrice = price * refinedDiscount;
  return price - discountedPrice;
}
